<div class="vacancy-search">
  <!-- Hero -->
  <div class="vacancy-search__hero">
    <div class="vacancy-hero">
      <h1 class="vacancy-hero__title">{{ 'vacancies.search.hero_title' | translate }}</h1>

      <div class="vacancy-search__form">
        <div class="vacancy-search__field">
          <div class="vacancy-search__field-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="11" cy="11" r="8"/><path d="m21 21-4.3-4.3"/>
            </svg>
          </div>
          <div class="vacancy-search__field-content">
            <label>{{ 'shared.what' | translate }}</label>
            <input type="text" [(ngModel)]="searchFunction" [placeholder]="'vacancies.search.placeholder_what' | translate" />
          </div>
        </div>

        <div class="vacancy-search__field">
          <div class="vacancy-search__field-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"/><circle cx="12" cy="10" r="3"/>
            </svg>
          </div>
          <div class="vacancy-search__field-content">
            <label>{{ 'shared.where' | translate }}</label>
            <input type="text" [(ngModel)]="searchLocation" [placeholder]="'vacancies.search.placeholder_where' | translate" />
          </div>
        </div>

        <lib-single-select-search
          class="vacancy-search__radius"
          [options]="radiusOptions"
          [control]="radiusControl"
          [placeholder]="'vacancies.search.distance_options.10' | translate"
          [myFloatLabel]="'never'"
          [forceControl]="true"
          [setControlValue]="true"
          [forceControlByOptions]="true"
          [disabledTyping]="true"
          [disableSearchOptionFiltering]="true"
          (changed)="onRadiusSelected($event)"
        ></lib-single-select-search>

        <button class="vacancy-search__submit" (click)="search()">{{ 'shared.search' | translate }}</button>
      </div>

      <p class="vacancy-search__results" *ngIf="hasSearched && (searchFunction || searchLocation)">
        {{ 'vacancies.search.results_prefix' | translate }}
        <strong *ngIf="searchFunction">{{ searchFunction }}</strong>
        <span *ngIf="searchLocation">{{ 'vacancies.search.results_in' | translate }}<strong>{{ searchLocation }}</strong></span>:
        {{ vacancies.length }}
      </p>
    </div>
  </div>

  <!-- Filters -->
  <div class="vacancy-search__filters-bar">
    <div class="vacancy-container">
      <div class="vacancy-filters">
        <div>
          <label class="vacancy-filters__label">{{ 'vacancies.search.filter_fields' | translate }}</label>
          <lib-single-select-search
            class="vacancy-filters__select"
            [options]="vakgebiedOptions"
            [control]="vakgebiedControl"
            [placeholder]="'shared.all_fields' | translate"
            [myFloatLabel]="'never'"
            [forceControl]="true"
            [setControlValue]="true"
            [forceControlByOptions]="true"
            [disabledTyping]="true"
            [disableSearchOptionFiltering]="true"
            (changed)="onVakgebiedSelected($event)"
          ></lib-single-select-search>
        </div>
        <div>
          <label class="vacancy-filters__label">{{ 'shared.education_level' | translate }}</label>
          <lib-single-select-search
            class="vacancy-filters__select"
            [options]="opleidingsniveauOptions"
            [control]="opleidingsniveauControl"
            [placeholder]="'shared.all_levels' | translate"
            [myFloatLabel]="'never'"
            [forceControl]="true"
            [setControlValue]="true"
            [forceControlByOptions]="true"
            [disabledTyping]="true"
            [disableSearchOptionFiltering]="true"
            (changed)="onOpleidingsniveauSelected($event)"
          ></lib-single-select-search>
        </div>
        <div>
          <label class="vacancy-filters__label">{{ 'vacancies.search.filter_hours' | translate }}</label>
          <lib-single-select-search
            class="vacancy-filters__select"
            [options]="aantalUrenOptions"
            [control]="aantalUrenControl"
            [placeholder]="'vacancies.search.filter_all_hours' | translate"
            [myFloatLabel]="'never'"
            [forceControl]="true"
            [setControlValue]="true"
            [forceControlByOptions]="true"
            [disabledTyping]="true"
            [disableSearchOptionFiltering]="true"
            (changed)="onAantalUrenSelected($event)"
          ></lib-single-select-search>
        </div>
        <div>
          <label class="vacancy-filters__label">{{ 'vacancies.search.filter_posted' | translate }}</label>
          <lib-single-select-search
            class="vacancy-filters__select"
            [options]="plaatsingsdatumOptions"
            [control]="plaatsingsdatumControl"
            [placeholder]="'vacancies.search.filter_all_dates' | translate"
            [myFloatLabel]="'never'"
            [forceControl]="true"
            [setControlValue]="true"
            [forceControlByOptions]="true"
            [disabledTyping]="true"
            [disableSearchOptionFiltering]="true"
            (changed)="onPlaatsingsdatumSelected($event)"
          ></lib-single-select-search>
        </div>
      </div>
    </div>
  </div>

  <!-- Grid -->
  <div class="vacancy-container vacancy-search__content">
    <div class="vacancy-grid">
      <bwc-vacancy-card
        *ngFor="let vacancy of visibleVacancies"
        [vacancy]="vacancy"
        [isLiked]="isLiked(vacancy.id)"
        (liked)="toggleLike($event)"
        (cardClick)="openDetail($event)"
      ></bwc-vacancy-card>
    </div>

    <div class="vacancy-load-more" *ngIf="hasMore">
      <button (click)="loadMore()">{{ 'shared.load_more' | translate }}</button>
    </div>
  </div>

  <bwc-vacancy-detail
    *ngIf="detailData"
    [data]="detailData"
    [style.--vacancy-detail-top.px]="112"
    (closed)="closeDetail()"
  ></bwc-vacancy-detail>
</div>
